export const SYSTEM_DEPENDENCY_FAILED_ERROR_MESSAGE =
  'System dependency failed';

export const SERVER_ERROR_MESSAGE = 'Server error';
